import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

const ArmenianFlag = ({ className = "flag-svg" }) => (
  <svg className={className} width="24" height="16" viewBox="0 0 25 17" style={{ display: 'block', borderRadius: 2, border: '1px solid rgba(0,0,0,0.12)' }}>
    <rect width="25" height="5.67" fill="#D90012" />
    <rect y="5.67" width="25" height="5.67" fill="#0033A0" />
    <rect y="11.34" width="25" height="5.67" fill="#F2A800" />
  </svg>
);

const RussianFlag = ({ className = "flag-svg" }) => (
  <svg className={className} width="24" height="16" viewBox="0 0 25 17" style={{ display: 'block', borderRadius: 2, border: '1px solid rgba(0,0,0,0.15)' }}>
    <rect width="25" height="5.67" fill="#FFFFFF" />
    <rect y="5.67" width="25" height="5.67" fill="#0039A6" />
    <rect y="11.34" width="25" height="5.67" fill="#D52B1E" />
  </svg>
);

const BritishFlag = ({ className = "flag-svg" }) => (
  <svg className={className} width="24" height="16" viewBox="0 0 60 40" style={{ display: 'block', borderRadius: 2, border: '1px solid rgba(0,0,0,0.15)' }}>
    <clipPath id="uk-flag-clip">
      <rect width="60" height="40" />
    </clipPath>
    <g clipPath="url(#uk-flag-clip)">
      <rect width="60" height="40" fill="#012169" />
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" strokeWidth="8" />
      <path d="M0,0 L60,40" stroke="#C8102E" strokeWidth="4" />
      <path d="M60,0 L0,40" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 v40 M0,20 h60" stroke="#fff" strokeWidth="12" />
      <path d="M30,0 v40 M0,20 h60" stroke="#C8102E" strokeWidth="7" />
    </g>
  </svg>
);

const languages = [
  { code: 'hy', name: 'Հայերեն', Flag: ArmenianFlag },
  { code: 'en', name: 'English', Flag: BritishFlag },
  { code: 'ru', name: 'Русский', Flag: RussianFlag }
];

const LanguageSwitcher = ({ style = {}, className = '', direction = 'horizontal', onSelect }) => {
  const { i18n } = useTranslation();
  let history, location;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    history = useHistory();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    location = useLocation();
  } catch (e) {
    // Graceful fallback if rendered outside Router context
  }

  const currentLang = (i18n.language || 'hy').slice(0, 2);
  const isVertical = direction === 'vertical';

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    if (typeof window !== 'undefined') {
      try {
        localStorage.setItem('i18nextLng', code);
      } catch (e) {}
    }

    if (onSelect) {
      onSelect(code);
    }

    // Sync URL path if history and location are available for SEO friendly URLs
    if (history && location) {
      const currentPath = location.pathname;
      let cleanPath = currentPath.replace(/^\/(en|ru|hy)(\/|$)/, '/');
      if (!cleanPath.startsWith('/')) {
        cleanPath = '/' + cleanPath;
      }

      let newPath;
      if (code === 'hy') {
        newPath = cleanPath; // Armenian is default root URL
      } else {
        newPath = cleanPath === '/' ? `/${code}` : `/${code}${cleanPath}`;
      }

      if (newPath !== currentPath) {
        history.push(newPath + location.search + location.hash);
      }
    }
  };

  return (
    <div
      className={`language-switcher ${isVertical ? 'vertical' : 'horizontal'} ${className}`}
      style={style}
      aria-label="Language selection"
    >
      {languages.map(({ code, name, Flag }) => {
        const isActive = currentLang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => handleLanguageChange(code)}
            title={name}
            aria-label={name}
            className={`lang-switcher-btn ${isVertical ? 'btn-vertical' : 'btn-horizontal'} ${isActive ? 'active' : ''}`}
          >
            <Flag />
            <span className={`lang-switcher-dot ${isVertical ? 'dot-side' : 'dot-bottom'}`} />
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
